import { useAppTheme } from "../../../../../useAppTheme";
import Box from "../../../../Box";
import ItemStem from "../../ItemStem";

type Props = {
	text: string;
	userSelect?: "none" | "text";
};

export const ItemStemCard = ({ text, userSelect }: Props) => {
	const theme = useAppTheme();
	return (
		<Box
			borderRadius={theme.roundness * 3}
			backgroundColor={theme.colors.surface}
			padding={16}
			gap={8}
		>
			<ItemStem
				text={text}
				paragraphMarginVertical={0}
				userSelect={userSelect}
			/>
		</Box>
	);
};
